import React from 'react';
import '../template-file-css/document-file-template.css';


export const NWBH_ContinuedStayCriteria = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='NWBH_ContinuedStayCriteria' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Adult 65D-30 Outpatient ASAM Level I</h3></p>

                <p className='w-750'>
                    <b>Circle all items in each dimension that apply to the client. Place a check in the 'yes' or 'no'
                        box that indicates validation or lack of validation for placement into this level of care.</b>
                </p>

                <table>
                    <tr>
                        <td className='w-200'>
                            <span className='eleHeader'>DIMENSIONS</span>
                        </td>
                        <td className='w-450'>
                            <span className='eleHeader'>CONTINUED STAY CRITERIA</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>Yes</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>No</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>ASAM Requirements</b>
                        </td>
                        <td className='w-450'>
                            <b>Meets criteria in Dimensions 1 and 2 and one of Dimensions 3,4,5 or 6</b>
                        </td>
                        <td className='w-50'>&nbsp;
                        </td>
                        <td className='w-50'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>Dimension 1:</b> Acute Intoxication and/or Withdrawal Potential
                        </td>
                        <td className='w-450'>Client is free from intoxication or withdrawal symptoms/risks
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish_Yes' name='rbEnglish' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish_No' name='rbEnglish' className='add-only' value='2' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>Dimension 2:</b> Biomedical Conditions and Complications
                        </td>
                        <td className='w-450'>None or very stable - The client's status in this dimension is characterized by one of the following:<br />
                            a. The client's biomedical conditions are stable enough to continue to participate in outpatient treatment; or
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish2_Yes' name='rbEnglish2' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish2_No' name='rbEnglish2' className='add-only' value='2' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;
                        </td>
                        <td className='w-450'>b. An intervening problem interrupted treatment but is now stable enough for the client to progress in treatment
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish22_Yes' name='rbEnglish22' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish22_No' name='rbEnglish22' className='add-only' value='2' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>Dimension 3:</b> Emotional, Behavioral or Cognitive Conditions and Complications
                        </td>
                        <td className='w-450'>None or very stable - The client's status in this dimension is characterized by one of the following:<br />
                            a. The client is making progress to reduce anxiety, guilt or depression, if present, but these symptoms have not been sufficiently resolved to permit discharge from treatment; or
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish3_Yes' name='rbEnglish3' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish3_No' name='rbEnglish3' className='add-only' value='2' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;
                        </td>
                        <td className='w-450'>b. An intervening emotional, behavioral or cognitive condition interrupted treatment but is now stable enough for the client to progress in treatment.
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish4_Yes' name='rbEnglish4' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish4_No' name='rbEnglish4' className='add-only' value='2' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>Dimension 4:</b> Readiness to Change
                        </td>
                        <td className='w-450'>Willing to cooperate but needs motivation and monitoring strategies - The client continues to work on treatment goals and objectives, but does not yet understand or accept his/her addiction sufficiently to maintain a self-directed recovery plan.
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish10_Yes' name='rbEnglish10' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish10_No' name='rbEnglish10' className='add-only' value='2' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>Dimension 5:</b> Relapse/Continued Use Potential
                        </td>
                        <td className='w-450'>Able to maintain abstinence and pursue recovery goals with minimal support as characterized by one of the followinbg:<br />
                            a. Client is not using alcohol or other drugs but remains mentally preoccupied with such use to the extent he/she is unable to address primary relationships social or work tasks; however, there are indications that with continued treatment, the client will effectively address these issues; or
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish14_Yes' name='rbEnglish14' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish14_No' name='rbEnglish14' className='add-only' value='2' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;
                        </td>
                        <td className='w-450'>b. Client is not alcohol or drugs and demonstrates minimal craving but requires continued work on the development of an alternative lifestyle, thinking patterns and emotional responses; however, the client is making progress toward these goals.
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish141_Yes' name='rbEnglish141' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish141_No' name='rbEnglish141' className='add-only' value='2' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <b>Dimension 6:</b> Recovery Environment
                        </td>
                        <td className='w-450'>Supportive recovery environment and/or client has skills to cope - The social environment remains non-supportive or has deteriorated, but the clilent is making sufficient progress in learning social and related coping skills to function in the environment without using substances.
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish15_Yes' name='rbEnglish15' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish15_No' name='rbEnglish15' className='add-only' value='2' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;
                        </td>
                        <td className='w-450'>b. Although the client does not have an ideal primary or social support system to assist with sobriety, he or she has demonstrated motivation and willingness to obtain such a support system; or
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish16_Yes' name='rbEnglish16' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish16_No' name='rbEnglish16' className='add-only' value='2' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;
                        </td>
                        <td className='w-450'>c. Family and significant others are supportive but require professional interventions to improve the client's chance of treatment success and recovery.
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish17_Yes' name='rbEnglish17' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish17_No' name='rbEnglish17' className='add-only' value='2' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;
                        </td>
                        <td className='w-450'>
                            <b>Dual Diagnosed Enhanced Programs</b>
                            In addition to the criteria listed above, (a) or (b) or (c) characterizes the client's status in Dimension 6.<br />
                            a. The client does not have an adequate primary or social suppot system and has mild inpairment in his or her abililty to obtain a support system; or
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish18_Yes' name='rbEnglish18' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish18_No' name='rbEnglish18' className='add-only' value='2' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;
                        </td>
                        <td className='w-450'>b. The family guardian or significant others require active family therapy or systems interventions to improve the client's chances of treatment success and recovery; or
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish19_Yes' name='rbEnglish19' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish19_No' name='rbEnglish19' className='add-only' value='2' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>&nbsp;
                        </td>
                        <td className='w-450'>c. The client's status in Dimension 6 is characterized by all of the followibng: (1) the client has a severe and persistent mental disorder or emotional, behavioral or cognitive problem, and (2) the client does not have an adequate family or social support system, and (3) the client is chronically impaired, however, not in imminent danger, had limited ability to establish a supportive recovery environemt. (The client however, does not have access to intensive outreach and case management services that can provide structure and allow him or her to work toward stabilizing both the substance and mental health related disorders). The client does however, have access to intensive outreach and case management services that can provide structure and allow them to work toward stabilizing both the substance related and mental disorders.
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish20_Yes' name='rbEnglish20' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbEnglish20_No' name='rbEnglish20' className='add-only' value='2' /></center>
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Recommendations/Notes:</span>
                    <textarea id='txtRecommendations' name='txtRecommendations' className='add-only'></textarea>
                </p>

            </div>
        </form>

    )
}

